import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { Store } from '@ngrx/store';
import { filter, take } from 'rxjs';

import * as pickupActions from 'src/app/stores/remote-pickup/remote-pickup.actions';
import * as pickupSelectors from 'src/app/stores/remote-pickup/remote-pickup.selector';
@Component({
  selector: 'frodo-order-overflow-area',
  templateUrl: './order-overflow-area.component.html',
  styleUrls: ['./order-overflow-area.component.scss'],
})
export class OrderOverflowAreaComponent implements OnInit {
  constructor(private dialogRef: MatDialogRef<OrderOverflowAreaComponent>, private store: Store) {}

  ngOnInit(): void {
    this.store
      .select(pickupSelectors.selectRemotePickupScheduleId)
      .pipe(
        take(1),
        filter((scheduleId) => !!scheduleId)
      )
      .subscribe((scheduleId) => {
        this.store.dispatch(pickupActions.startPickup({ scheduleId, isOverflowArea: true }));
      });
  }

  accept(): void {
    this.dialogRef.close();
    this.store.dispatch(pickupActions.clearRemotePickup());
  }
}
